import { useEffect, useState } from "react";
import { DataTable } from "../DataTable/DataTable";
import defaultAvatar from "../../assets/images/default_avatar.jpg";
import { LabService } from "../../services/api/LaborderService/lab.service";

interface LabHistoryInterface {
  patientName: string;
  profileImage: string | null;
  mobileNumber: string;
  age: string;
  gender: string;
  date: string;
  clinicName: string;
}

const History = () => {
  const [historydata, setHistoryData] = useState<LabHistoryInterface[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItemsCount, setTotalItemsCount] = useState(0);

  useEffect(() => {
    const fetchLabOrder = async () => {
      try {
        const response = await LabService.getLabOrdersListing(
          currentPage,
          pageSize,
          {
            isLabtestOrder: true,
            status:"REPORT_GENERATED"
          }
        );
        console.log("labTest", response);
        if (response.success && response.data) {
          const formattedData = response.data.data.map((order: any) => ({
            patientName: order.patientDetails?.patientName || "N/A",
            profileImage: order.patientDetails?.patientProfileImage || null,
            mobileNumber: order.patientDetails?.patientMobileNumber || "N/A",
            age: order.patientDetails?.patientAge || "N/A",
            gender: order.patientDetails?.patientGender || "N/A",
            date: order.orderDate
              ? new Date(order.orderDate).toLocaleDateString()
              : "N/A",
            clinicName: order.clinicDetails?.clinicName || "N/A",
            clinicImage: order.clinicDetails?.clinicProfileImage || null,
          }));
          setHistoryData(formattedData);
          setCurrentPage(response.data.pagination.page);
          setTotalPages(response.data.pagination.totalPages);
          setTotalItemsCount(response.data.pagination.totalCount);
          setPageSize(response.data.pagination.pageSize);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLabOrder();
  }, [currentPage, pageSize]);

  const columns = [
    {
      key: "patient name",
      title: "Patient Name",
      sortable: true,
      width: "w-[200px]",
      render: (lab: LabHistoryInterface) => (
        <div className="flex items-center">
          <img
            src={lab.profileImage || defaultAvatar}
            alt={lab.patientName}
            className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
          />
          <div>
            <div className="font-medium text-gray-900">{lab.patientName}</div>
          </div>
        </div>
      ),
    },
    {
      key: "mobile number",
      title: "Mobile Number",
      width: "w-[200px]",
      render: (lab: LabHistoryInterface) => (
        <div>
          <div className="text-sm">{lab.mobileNumber}</div>
        </div>
      ),
    },
    {
      key: "age",
      title: "Age",
      width: "w-[200px]",
      render: (lab: LabHistoryInterface) => (
        <div>
          <div className="text-sm">{lab.age}</div>
        </div>
      ),
    },
    {
      key: "gender",
      title: "Gender",
      width: "w-[200px]",
      render: (lab: LabHistoryInterface) => (
        <div>
          <div className="text-sm">{lab.gender}</div>
        </div>
      ),
    },
    {
      key: "clinic name",
      title: "Clinic Name",
      sortable: true,
      width: "w-[200px]",
      render: (lab: LabHistoryInterface & { clinicImage?: string }) => (
        <div className="flex items-center">
          <img
            src={lab.clinicImage || defaultAvatar}
            alt={lab.clinicName}
            className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
          />
          <div>
            <div className="font-medium text-gray-900">{lab.clinicName}</div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        data={historydata}
        columns={columns}
        isLoading={isLoading}
        pagination={{
          currentPage,
          setCurrentPage,
          setTotalPages,
          totalPages,
          pageSize,
          setPageSize,
        }}
      />
    </>
  );
};

export default History;
